import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { api } from "../../redux/api";

function RemoteRevisionHistoryModal({
  open,
  onClose,
  node,
  remoteToken,
  remoteUrl,
  connectionId,
  urlParams = {},
}) {
  const dispatch = useDispatch();
  const [revisions, setRevisions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open || !node?.isTemplateFile || !remoteToken || !urlParams?.account) {
      setRevisions([]);
      return;
    }
    setLoading(true);
    setError("");
    dispatch(
      api.endpoints.getRemoteRevisionHistory.initiate({
        account: urlParams.account,
        remote_token: remoteToken,
        remote_url: remoteUrl,
        user: urlParams.user,
        connection_id: connectionId,
        wf_group_name: node?.workflowGroup || "",
        folder_path: node?.folderPath || node?.parent?.folderPath || "",
        template_name: node?.title || "",
      }),
      { forceRefetch: true },
    )
      .then((result) => {
        setLoading(false);
        if (result?.error) {
          setError(result?.error?.data?.message || "Failed to load revision history.");
          setRevisions([]);
          return;
        }
        if (result?.data?.current_state === "SUCCESS") {
          setRevisions(result?.data?.data?.revisions || []);
        } else {
          setRevisions([]);
        }
      })
      .catch(() => {
        setLoading(false);
        setError("Failed to load revision history.");
        setRevisions([]);
      });
  }, [
    open,
    node,
    remoteToken,
    remoteUrl,
    connectionId,
    urlParams?.account,
    urlParams?.user,
    dispatch,
  ]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Server Revision History - {node?.title}</span>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>
        {loading && (
          <div style={{ display: "flex", justifyContent: "center", padding: 24 }}>
            <CircularProgress />
          </div>
        )}
        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
        {!loading && !error && revisions.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No revision history found.
          </Typography>
        )}
        {!loading && !error && revisions.length > 0 && (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Revision</TableCell>
                <TableCell>User</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Comment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {revisions.map((rev, i) => (
                <TableRow key={i}>
                  <TableCell>{rev.revisionId}</TableCell>
                  <TableCell>{rev.user}</TableCell>
                  <TableCell>{rev.date}</TableCell>
                  <TableCell>{rev.comment}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

export default RemoteRevisionHistoryModal;
